import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { DnsModel } from 'src/app/shared/models/usuarios/user.model';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '../login/authentication/authentication.service';
import { TaxisLineaModel, TaxisServCabModel, TaxisTarifasCabModel, TaxisUsuariosModel } from 'src/app/shared/models/taxis/taxis.model';
import { VTCServicioModel, VtcSearchTablaPayload, VtcServicioTabla, VtcServicioTablaResponse } from 'src/app/shared/models/servicios/vtc.model';
import { SubProcesosService } from './sub-procesos.service';

@Injectable({
  providedIn: 'root'
})
export class TaxisService {
  get url(): string {
    return this.auth?.urlVTC;
  };

  constructor(private http: HttpClient, private auth: AuthenticationService,
    private sPro: SubProcesosService
  ) {
  }

  loggin(user, pass): Observable<string> {
    var url = `${this.url}Logging/getVehiculobyUser?login=${user}&pass=${pass}`;
    return this.http.get<string>(url);
  }

  getDatosGuardados(iddevice): Observable<DnsModel> {
    console.log("Recuperando datos AppCC API");
    var url = `${this.formUrlAppCC(`login/authenticatedevice?iddevice=${iddevice}&app=2`)}`;
    return this.http.get<DnsModel>(url);
  }

  setDatosGuardadosTaller(): Observable<any> {
    console.log("Guardando datos AppCC API Taller");
    var devideId = this.sPro.getDeviceId();
    console.log("Device ID", devideId);

    var url = `${this.formUrlAppCC("login/registerdevice?device=")}${this.sPro.getDeviceId()}&app=1&holder=${this.auth.currentDns}`;
    return this.http.get<any>(url);
  }

  setDatosGuardadosTrafico(): Observable<any> {
    console.log("Guardando datos AppCC API Trafico");
    var devideId = this.sPro.getDeviceId();
    console.log("Device ID", devideId);

    var url = `${this.formUrlAppCC("login/registerdevice?device=")}${this.sPro.getDeviceId()}&app=2&holder=${this.auth.currentDns}`;
    return this.http.get<any>(url);
  }

  RemoveDatosGuardadosTaller(): Observable<any> {
    console.log("ELIMINANDO datos AppCC API Taller");
    var devideId = this.sPro.getDeviceId();
    console.log("Device ID", devideId);

    var url = `${this.formUrlAppCC("login/removeregisterdevice?device=")}${this.sPro.getDeviceId()}&app=1&holder=${this.auth.currentDns}`;
    return this.http.get<any>(url);
  }

  RemoveDatosGuardadosTrafico(): Observable<any> {
    console.log("ELIMINANDO datos AppCC API Trafico");
    var devideId = this.sPro.getDeviceId();
    console.log("Device ID", devideId);

    var url = `${this.formUrlAppCC("login/removeregisterdevice?device=")}${this.sPro.getDeviceId()}&app=2&holder=${this.auth.currentDns}`;
    return this.http.get<any>(url);
  }

  getTaxisServLinSinCerrarPorVehiculo(): Observable<TaxisLineaModel[]> {
    var url = `${this.url}Taxis/getTaxisServLinSinCerrarPorVehiculo?codigbus=${this.auth.currentUserValue.loginTaxis.vehiculo.codigbus}`;
    return this.http.get<TaxisLineaModel[]>(url);
  }

  getServiciosActivos(): Observable<TaxisServCabModel[]> {
    var url = `${this.url}Taxis/GetServiciosActivos?codigbus=${this.auth.currentUserValue.loginTaxis.vehiculo.codigbus}`;
    return this.http.get<TaxisServCabModel[]>(url);
  }

  esVTC(): Observable<boolean> {
    var url = `${this.url}Taxis/esVTC?codvehiculo=${this.auth.currentUserValue.loginTaxis.vehiculo.codigbus}`;
    return this.http.get<boolean>(url);
  }

  getVehiculosAndLineasTaxisCabecera(id_servicio: number): Observable<any> {
    var url = `${this.url}Taxis/GetInfoServicio?id_servicio=${id_servicio}&codigbus=${this.auth.currentUserValue.loginTaxis.vehiculo.codigbus}`;
    return this.http.get<any>(url);
  }

  getUsuariosTaxis(id_servicio: number, id_ruta: number): Observable<TaxisUsuariosModel[]> {
    var url = `${this.url}Taxis/GetUsuariosServicioRuta?id_servicio=${id_servicio}&id_ruta=${id_ruta}`;
    return this.http.get<TaxisUsuariosModel[]>(url);
  }

  crearServicioVTC(data: VTCServicioModel): Observable<any> {
    var url = `${this.url}Servicios/CrearServicioTaxis`;
    return this.http.post<any>(url, data);

  }

  cerrarVTC(id: number): Observable<any> {
    var url = `${this.url}Servicios/FinalizarServicio/${id}`;
    return this.http.get<any>(url);
  }

  crearServicioTaxis(linea): Observable<any> {
    var url = `${this.url}Taxis/AddLinea`;
    return this.http.post<any>(url, linea);
  }

  iniciarVTC(id: number) {
    var url = `${this.url}Servicios/IniciarServicio/${id}`;
    return this.http.get<any>(url);
  }

  searchServiceVTC(fecha: Date, numempre: number): Observable<VtcServicioTablaResponse> {
    const take = 100;
    var data: VtcSearchTablaPayload = {
      empresa: [{ numempre }],
      fechaDesde: fecha,
      fechaHasta: fecha,
      montados: true,
      cliente: [],
      departamentos: [],
      estados: [],
      matricula: null,
      numorden: null,
      vehiculos: [],
      skip: 0,
      take
    };
    var url = `${this.url}Servicios/SearchVtcTabla`;

    const fetchAll = (skip = 0, acumulado: VtcServicioTabla[] = []): Observable<VtcServicioTablaResponse> => {
      return this.http.post<VtcServicioTablaResponse>(url, { ...data, skip, take }).pipe(
        switchMap(res => {
          const pagina: VtcServicioTabla[] = res?.servicios ?? [];
          const servicios = [...acumulado, ...pagina];

          if (pagina.length < take) {
            return of({
              ...(res ?? {}),
              servicios,
              total: res?.total
            });
          }

          return fetchAll(skip + take, servicios);
        })
      );
    };

    return fetchAll();
  }

  deleteService(idServ, numServ): Observable<void> {
    var url = `${this.url}Taxis/BorrarLinea?id_servicio=${idServ}&numservicio=${numServ}`;
    return this.http.put<void>(url, null);
  }

  anularVtc(codservicio, idusuario?): Observable<void> {
    var usu = idusuario ?? 0;
    var url = `${this.url}Servicios/AnularServicio/${codservicio}/${usu}`;
    return this.http.get<void>(url);
  }

  updateTaxi(linea): Observable<any> {
    var url = `${this.url}Taxis/UpdateTaxi`;
    return this.http.post<any>(url, linea);
  }

  getTarifasTaxisByService(idservicio): Observable<TaxisTarifasCabModel[]> {
    var url = `${this.url}Taxis/GetTaxisTarifasByService/IdService?id=${idservicio}`;
    return this.http.get<TaxisTarifasCabModel[]>(url);
  }

  formUrlAppCC(endpoint) {
    console.log("formUrlAppCC", `${this.auth.urlTrafico}${endpoint}`);
    return `${this.auth.urlTrafico}${endpoint}`;
  }
}
